export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: this.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 90,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'accessoriesNo',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_accessories_no') || '辅料编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'accessoriesName',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_accessories_name') || '辅料名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'accessoriesNameEn',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_accessories_name_en') || '辅料名称英文',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'accessoriesDictName',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_category_name') || '辅料类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'supName',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_sup_name') || '供应商名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'unitPrice',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_unit_price') || '单价',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'moq',
    align: 'center',
    minWidth: 150,
    title: this.$l('table_label_moq') || '起订量',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'accessoriesStatus',
    align: 'center',
    width: 150,
    title: this.$l('table_label_status') || '有效状态',
    slots: {default: 'status'},
    filters: [
      {label: '有效', value: 'Y'},
      {label: '无效', value: 'N'},
    ],
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
